// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__s5oXx","main":"MainLayout_main__UUnvm","content":"MainLayout_content__nOiKO"};